export default {
  
  en: {
    workorder: 'Number',
    collector: 'collector',
    createRepayOrder: 'Create payment order',
    collectLink: 'Repayment link',
    modifyStatus: 'Modify status',
    enterAmount: 'Please enter the amount',
    confirmStatus: 'Confirm processing status',
    wordOrderStatus_0 :'Not processed',
    wordOrderStatus_1 :'Waiting for processing by the payment company',
    wordOrderStatus_2 :'The payment company prompts that the voucher has been used and needs to be uploaded again.',
    wordOrderStatus_3 :'Invalid certificate, need to re-upload',
    wordOrderStatus_4 :'No operation has been performed to upload the voucher and the order has been settled',
    wordOrderStatus_5 :'hand settled',
  },
  es: {
    workorder: 'Número',
    collector: 'Asesor',
    createRepayOrder: 'Crear orden de pago',
    collectLink: 'Obtener liga de pago',
    modifyStatus: 'Modificar estado',
    enterAmount: 'Por favor ingrese la cantidad',
    confirmStatus: 'Confirmar el estado del procesamiento',
    wordOrderStatus_0 :'No procesado',
    wordOrderStatus_1 :'Esperando que la empresa de pago procese',
    wordOrderStatus_2 :'Empresa de pago notifica que el comprobante ya se usó y necesita subir de nuevo',
    wordOrderStatus_3 :'Comprobante inválido,necesita subir de nuevo',
    wordOrderStatus_4 :'No procesado y se liquidó el pedido',
    wordOrderStatus_5 :'hand settled',
  }
}